<template>
  <div>
    <q-chip
      v-for="detail in orderItem.details"
      :key="Object.keys(detail)[0]"
      square
      :color="color"
      :text-color="textColor"
      :label="detailLabel(detail)"
    />
  </div>
</template>

<script>

export default {
  name: 'OrderItemDetails',
  props: {
    props: {
      type: Object,
      required: true
    }
  },
  computed: {
    orderItem () {
      return this.props.row
    },
    color () {
      return 'green-3'
    },
    textColor () {
      return 'dark'
    }
  },
  methods: {
    detailLabel (detail) {
      if (this.orderItem.isGiftCard) {
        if (!_.isNil(detail.name)) {
          return 'Name: ' + detail.name
        }
        return 'Recipient Email: ' + detail.recipient_email + ', Message: ' + detail.message
      }

      return _.startCase(Object.keys(detail)) + ': ' + detail[Object.keys(detail)]
    }
  }
}

</script>
